import { TextInputFormikField } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export function WebhookURLInput() {
  const { t } = useTranslation();

  return (
    <TextInputFormikField
      label={t("Webhook URL")}
      testID="webhook-url"
      name="webhook_url"
      description={t("The URL to send the webhook to.")}
      type="url"
      isRequired
    />
  );
}
